function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M1,4.03812051 C1,2.36021288 2.35989741,1 4.03741588,1 C5.22096677,1 6.24641158,1.67708958 6.7476992,2.6651327 C7.17907496,2.56304923 7.63105066,2.51469913 8.09578686,2.51891678 C10.2969239,2.53889288 12.6898917,3.76086295 14.8988728,5.91725318 C15.3479158,6.35414532 16.0465463,6.50782996 16.6765102,6.47055872 L16.9233556,6.45376178 C17.5172595,6.45915166 18.283481,6.79866248 18.7281388,7.27579942 C19.0999827,7.67480388 19.0890684,8.29670424 18.7034529,8.68240918 L16.4654532,10.9209194 C17.3497455,12.4185233 17.187652,14.3631324 15.9791728,15.6968616 L15.8397498,15.8433279 C14.5053571,17.1780301 12.4714579,17.3866323 10.9184118,16.4691344 L8.68480877,18.7033775 C8.32103839,19.0672323 7.74230099,19.100386 7.33937703,18.7804524 C6.81404783,18.3633254 6.50290716,17.6801852 6.46872164,16.7993646 L6.4474574,16.2591598 C6.40751218,15.6375979 6.27342064,15.2455555 5.93483552,14.9001591 C3.2982359,12.2022875 2.09233935,9.24710542 2.66875166,6.74977708 C1.67910255,6.25091359 1,5.2238419 1,4.03812051 Z M14.932415,12.455021 L12.4524402,14.935839 C13.081976,15.1037327 13.7766412,14.9631535 14.2971101,14.5141014 L14.4078982,14.4111442 C14.9377412,13.8811783 15.1125801,13.1305899 14.932415,12.455021 Z M7.00220655,4.69001346 L6.97466081,4.81484706 C6.68670417,5.90718898 5.80583435,6.75876563 4.69717179,7.00437186 C4.17602985,8.75689182 5.09370028,11.1419794 7.38179004,13.4832437 C8.05720543,14.172243 8.35327296,14.9389527 8.44850378,15.8880879 L8.46213452,16.0617359 L16.040209,8.48190346 L15.9426671,8.47448414 C15.1351346,8.3927193 14.3423455,8.11360058 13.6669597,7.53363718 L13.4857515,7.36792863 C11.6178221,5.54447213 9.68771311,4.55886112 8.07741479,4.54424709 C7.69552017,4.54078126 7.33558193,4.59012621 7.00220655,4.69001346 Z M4.03741588,3.02541367 C3.47824306,3.02541367 3.02494392,3.47881797 3.02494392,4.03812051 C3.02494392,4.59742305 3.47824306,5.05082735 4.03741588,5.05082735 C4.59658871,5.05082735 5.04988784,4.59742305 5.04988784,4.03812051 C5.04988784,3.47881797 4.59658871,3.02541367 4.03741588,3.02541367 Z",
  id: "path-1"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Clean-design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Pazi\\u0146ojumi",
  transform: "translate(-20, -420)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu",
  transform: "translate(0, 146)"
}, /*#__PURE__*/React.createElement("g", {
  id: 7,
  transform: "translate(0, 264)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Content",
  transform: "translate(20, 9)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Sidebar-/-Notifications",
  transform: "translate(0, 1)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "viewbox",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "icon",
  fill: "#667380",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Icon-color",
  fill: "#667380",
  mask: "url(#mask-2)",
  x: 0,
  y: 0,
  width: 20,
  height: 20
})))))));

function SvgIcSidebarNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1827E0FC-91B7-4222-8F17-4513975FFFC6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarNotifications);
export default __webpack_public_path__ + "static/media/ic-sidebar-notifications.610801a4.svg";
export { ForwardRef as ReactComponent };